import styled from "styled-components";

export const TableContainer = styled.div`
  overflow-x: auto;
  margin: 20px 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
`;

export const THead = styled.thead`
  background-color: #f5f5f5;
  border-bottom: 2px solid #e0e0e0;
`;

export const TBody = styled.tbody`
  tr:nth-child(even) {
    background-color: #fafafa;
  }

  tr:hover {
    background-color: #f0f0f0;
  }
`;

export const Th = styled.th`
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
`;

export const Tr = styled.tr`
  transition: background-color 0.2s;
`;

export const Td = styled.td`
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  color: #555;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: #f5f5f5;
  border-radius: 0 0 8px 8px;
  flex-wrap: wrap;
  gap: 10px;
`;

export const PaginationButton = styled.button`
  padding: 6px 12px;
  margin: 0 2px;
  background-color: ${(props) => (props.disabled ? "#e0e0e0" : "#007bff")};
  color: ${(props) => (props.disabled ? "#999" : "white")};
  border: none;
  border-radius: 4px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${(props) => (props.disabled ? "#e0e0e0" : "#0056b3")};
  }
`;

export const PageInfo = styled.div`
  display: flex;
  gap: 15px;
  color: #555;
  font-size: 14px;
`;

export const SelectionBar = styled.div`
  padding: 10px;
  margin-bottom: 10px;
  background-color: #f0f0f0;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;
